import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/inventarioFisico';

import Select from 'react-select';

import {api} from '../../actions/_request';
import ModalTablas from '../../components/catalogos/modal_tablas';

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);



class ModalHistoricos extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
          data : [],
          referencia : '',
          loading: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);           
        this.resetModal= this.resetModal.bind(this);            
        this.handleSelectChange= this.handleSelectChange.bind(this);
          
        this.retorno= this.retorno.bind(this);  
        this.handleClose= this.handleClose.bind(this);
    }
   
    handleSelectChange(select, name) {
        const value = select === null ? null : select.value;
        this.setState({
            impuesto: {
                ...this.state.impuesto,
                [name]: value
            }
        });
    }

    componentDidMount()
    {    

    }

     handleClose (event) {
     
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        console.log('entras')
         switch (name) {
            case "referencia":                  
                campo = "referencia";
                tabla="/inventarioFisico/buscarReferencia/"+this.state.referencia;
                break;  
        }

        this.setState({
          loading : true
        })

        let self =this;
        if(value!=""){
            api().get(`${tabla}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        
                        let  retorno=response.data;
                        self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "La referencia introducida no existe");
                          self.retorno(response.data,campo,vaciar,value);
                     }        
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
   }

    retorno(objeto,campo,vacio=0,valor=""){
       	console.log('renglon---->',objeto);
        let self =this;
        let {data} = this.state;
        switch (campo) {
            case "referencia":
              data = objeto;
                  break;
        }  

       if(vacio==1){
        console.log('vaciar')
        if(campo == 'referencia')
        	data= [];
        
        campo =0;

       }
         self.setState({
            data : data,   
            loading : false                 
        })
    }

    resetModal(){
        this.setState({
            inventarioFisico: {

                id:0,               
                nombre:'',
                telefono:'',
                codigo:'',
                direccion:'',
               usuario_id: parseInt(this.props.auth.user.id),               
            },
            action: 'save',
             activeTab: '1',
        });
        
    }

    handleInputChange(event) {
        let {inventarioFisico} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            referencia : value
        });
    }
    
    render()
    {

        let {referencia}=this.state;
        let {loading}=this.state;
        return( 

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                   <div className="row justify-content-center">
                   		<div className="col-md-5"> 
	                        <div className="form-group">
	                            <label className="-block">Referencia:</label>
	                            <Input
	                            placeholder=""
	                            type="text"
	                            name="referencia"
	                            value={referencia}
	                            onChange={ this.handleInputChange}
	                            onBlur={this.handleClose}
	                            className="input_button_sm"
	                            />
	                        </div>
	                    </div>
                   </div>
                   <div className="row">
                      <div className="col-12">
                        <ReactTable
                          className = "-striped -highlight"
                          columns   = {[  
                            {Header: 'Codigo', accessor: 'item_codigo',maxWidth:150 },
                            {Header: 'Nombre', accessor: 'label'},
                            {Header: 'Almacen', accessor: 'almacen_nombre'},
                            {Header: 'Linea', accessor: 'linea' },
                            {Header: 'Fisico', accessor: 'fisico' , filterable: false},
                            {Header: 'Existencia', accessor: 'existencia',filterable: false}     
                          ]}

                          data={this.state.data}
                          loading={loading}
                          filterable
                          defaultPageSize={10} 
                        />
                      </div>
                   </div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.inventarioFisico.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="secondary" onClick={this.props.toggle}>
                                CERRAR
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        inventarioFisico : state.inventarioFisico,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(ModalHistoricos)


// WEBPACK FOOTER //
// ./src/views/inventarioFisico/inventarioFisicoHistoricos.js